import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { MeResponse } from "@telecurb/shared";
import { workosAuthClient } from "./workos-client";

export const ME_QUERY_KEY = ["me"] as const;

// Subscribe to the current user. Backed by React Query so concurrent callers
// share one in-flight request and one cached value — no need for an auth
// context just to dedupe /me.
export function useMe(): UseQueryResult<MeResponse | null> {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: () => workosAuthClient.getCurrentUser(),
    // /me doesn't change mid-session; explicit invalidate after sign-in /
    // accept-invite is how we refresh it.
    staleTime: Infinity,
    // 401 means signed out, not a transient failure. Retrying would just
    // delay the redirect to /sign-in.
    retry: false,
  });
}
